import cn from 'classnames';
import { getDate } from 'date-fns';
import type React from 'react';

import { ArrowIosLeft, ArrowIosRight, Calendar as CalendarIcon } from '@shared/assets';
import { IconButton } from '@shared/ui';

import { useCalendarMode, useDate, useDay, useMonth, useSessionLoader } from '../../model';
import { Day } from '../day';
import { Month } from '../month';
import { OfflineSessions } from '../offline-sessions';
import { OnlineSessions } from '../online-sessions';
import { SelectedDate } from '../selected-date';
import { Week } from '../week';
import * as st from './styles.module.scss';

type Props = {
	mode: string;
	coachId: number;
	onClick: (id: number) => void;
	isIndividualCoachCard?: boolean;
};

export const Calendar: React.FC<Props> = ({
	mode,
	coachId,
	onClick,
	isIndividualCoachCard = false,
}) => {
	const { showCalendar, toggleMode } = useCalendarMode();
	const { date, add, subtract, changeDate } = useDate(showCalendar);
	const { monthDates } = useMonth(date);
	const { available } = useSessionLoader(date, coachId);
	const { getSessionsInDay } = useDay();

	return (
		<div
			className={cn(st.schedule, isIndividualCoachCard && st['scheduleMode'])}
			onClick={(e) => e.stopPropagation()}
		>
			<section className={st.buttons}>
				<SelectedDate date={date} showCalendar={showCalendar} />
				<IconButton variant={'dark'} onClick={subtract}>
					<ArrowIosLeft />
				</IconButton>
				<IconButton variant={'dark'} onClick={add}>
					<ArrowIosRight />
				</IconButton>
				{/* <TextButton
					onClick={(e) => {
						e.stopPropagation();
						changeDate(new Date());
					}}
				>
					Сегодня
				</TextButton> */}
				<IconButton onClick={toggleMode} variant={'dark'}>
					<CalendarIcon />
				</IconButton>
			</section>

			<section className={st.workspace}>
				{showCalendar && (
					<Month>
						{monthDates.map((week) => (
							<Week key={week[0].toDateString()}>
								{week.map((day) => {
									const sessionInDay = getSessionsInDay(available, day, mode);

									return (
										<Day
											key={day.toDateString()}
											selectedDate={date}
											date={day}
											onClick={(e) => {
												toggleMode(e);
												changeDate(day);
											}}
											disabled={sessionInDay.length === 0}
										>
											{sessionInDay.length > 0 ? getDate(day) : '--'}
										</Day>
									);
								})}
							</Week>
						))}
					</Month>
				)}

				{!showCalendar && (
					<>
						{mode === 'ON' && (
							<OnlineSessions
								sessions={getSessionsInDay(available, date, mode)}
								onClick={onClick}
							/>
						)}
						{mode === 'OF' && (
							<OfflineSessions
								sessions={getSessionsInDay(available, date, mode)}
								onClick={onClick}
							/>
						)}
					</>
				)}
			</section>
		</div>
	);
};
